import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useMe } from '@/common/entities/me/model/me'
import { useOptionalToast } from '@/common/ui/Toast/toastContext'
import { getPrimaryMissingProfileField, type MissingProfileField } from './profileCompleteness'

const PROFILE_USER_PATH = '/app/profile/user'

const getToastStorageKey = (field: MissingProfileField): string => `incomplete_profile_toast:${field}`

const getIncompleteProfileToastContent = (field: MissingProfileField) => {
    const profileLink = (
        <Link className='underline text-[#ffffff] hover:text-[#9161ed]' to={PROFILE_USER_PATH}>
            профиле
        </Link>
    )

    if (field === 'email') {
        return <>Укажите email в {profileLink}</>
    }

    return <>Укажите пароль в {profileLink}</>
}

export const useIncompleteProfileToast = () => {
    const { me, isSuccess } = useMe()
    const toast = useOptionalToast()
    const location = useLocation()

    useEffect(() => {
        if (!isSuccess || !me || !toast) {
            return
        }

        if (location.pathname === PROFILE_USER_PATH) {
            return
        }

        const primaryField = getPrimaryMissingProfileField(me)

        if (!primaryField) {
            return
        }

        const storageKey = getToastStorageKey(primaryField)

        if (sessionStorage.getItem(storageKey) === '1') {
            return
        }

        sessionStorage.setItem(storageKey, '1')

        if (location.pathname === PROFILE_USER_PATH) {
            return
        }

        toast.showToast({
            type: 'warning',
            message: getIncompleteProfileToastContent(primaryField),
        })
    }, [isSuccess, location.pathname, me, toast])
}
